"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ShieldCheck } from "lucide-react";
export default function TheBriefing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="265248" id="the-briefing" className="bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-background/95 z-10" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/50 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/architectural_blueprint_pattern.png)] bg-cover bg-center opacity-[0.02] mix-blend-overlay" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 text-center flex flex-col items-center justify-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-md border border-secondary/20 text-secondary mb-8 bg-primary">
          <ShieldCheck className="w-4 h-4" />
          <span className="text-sm font-mono tracking-widest uppercase">Legal Excellence</span>
        </div>

        <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold uppercase tracking-tighter leading-[0.9] mb-8 text-foreground drop-shadow-2xl max-w-5xl mx-auto">
          The Briefing <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-foreground to-foreground/40">
            Sterling Law Associates.
          </span>
        </h2>
        
        <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default mb-10">
          A tradition of unshakeable stability and elite intelligence. We provide the architectural precision required for complex legal landscapes in family law and real estate.
        </p>

        <Button asChild size="lg" className="h-14 px-8 text-base font-mono font-bold tracking-widest uppercase rounded-md bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg">
          <Link to="/TheFirmPage">
            Our Philosophy
          </Link>
        </Button>
      </div>

      {}
      <div className="absolute bottom-8 right-8 md:bottom-16 md:right-16 z-30 pointer-events-none">
        <div className="relative w-28 h-28 md:w-40 md:h-40">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_silver_seal.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_silver_seal.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_silver_seal.png-wvc-sizes" alt="Sterling Law Associates Seal" className="w-full h-full object-contain drop-shadow-2xl opacity-40 grayscale" loading="lazy" />
        </div>
      </div>
    </section>;
}